import request from '@/utils/request';

export function getMenu() {
  return request({
    url: '/menu/getMenu',
    method: 'post'
  });
}

export function listRouterData(list) {
  var routerList = [];
  list.forEach(function (item) {
    var newRoute = {};
    for (var key in item) {
      newRoute[key] = item[key];
      if (key == 'component') {
        newRoute.component = function (resolve) {
          return require(['@/views' + item.component], resolve);
        };
      }
      if (key == 'children' && item.children && item.children.length) {
        newRoute.children = listRouterData(item.children);
      }
    }
    routerList.push(newRoute);
  });
  return routerList;
}